import { MINCOL } from "../../../constants/const";
import DropdownFilter from "../SD_einsehen/DropdownFilter";

export const vvHeader = [
    {
        accessor: 'vertrag',
        Header: 'Verkehrsvertrag',
        // Filter: DropdownFilter,
        width: '30em'
    },
    {
        accessor: 'art',
        Header: 'Vertragsart',
        Filter: DropdownFilter,
        width: MINCOL
    },
    {
        accessor: 'evu',
        Header: 'Eisenbahnverkehrsunternehmen',
        Filter: DropdownFilter,
        width: '15em'
    },
    {
        accessor: 'korr_zvs_str',
        Header: 'zugehörige Zweckverbände',
        width: '16em'
    },
    {
        Header: 'Gültigkeit',
        columns: [
            {
                accessor: 'beginn',
                Header: 'seit',
                width: MINCOL
            },
            {
                accessor: 'ende',
                Header: 'bis',
                width: MINCOL
            },
        ]
    },

    {
        Header: 'seit',
        unused: true,
        width: MINCOL
    },
    {
        Header: 'bis',
        unused: true,
        width: MINCOL
    },
]

export const csvHeaderVv = [
    'Verkehrsvertrag',
    'Vertragsart',
    'Eisenbahnverkehrsunternehmen',
    'zugehörige Zweckverbände',
    'seit',
    'bis',
    'Kommentar'
]